import { produce } from 'immer';
import _ from 'lodash';
import { normalize } from 'normalizr';

import { FORM_BUNDLE_FORM_ACTION_TYPE, formBundleFormsSchema } from 'store/forms/actions';
import { RESET_STATE } from 'store/global/actions';

const initialState = {};

const formBundleFormsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case FORM_BUNDLE_FORM_ACTION_TYPE.GET_FORMS:
        return payload;

      case FORM_BUNDLE_FORM_ACTION_TYPE.REORDER_FORMS: {
        const sortedData = _.sortBy(draft, ({ formId }) => payload.indexOf(formId));

        return normalize(sortedData, [formBundleFormsSchema]).entities.data;
      }

      case FORM_BUNDLE_FORM_ACTION_TYPE.REORDER_BY_ELEMENT_ID: {
        const sortedData = _.sortBy(draft, ({ formBundleFormId }) =>
          payload.indexOf(formBundleFormId),
        ).map((item, index) => ({ ...item, orderNumber: index }));

        return normalize(sortedData, [formBundleFormsSchema]).entities.data;
      }

      case FORM_BUNDLE_FORM_ACTION_TYPE.EDIT_FORM:
      case FORM_BUNDLE_FORM_ACTION_TYPE.CREATE_FORM:
        draft[payload.formBundleFormId] = payload;
        break;

      case FORM_BUNDLE_FORM_ACTION_TYPE.DELETE_FORM:
        delete draft[payload.formBundleFormId];
        break;

      case FORM_BUNDLE_FORM_ACTION_TYPE.RESET_STORE:
      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default formBundleFormsReducer;
